package fr.arcplex.network.model

/**
 * Film detail: Coherence payload when the backend has one, legacy screen as fallback.
 */
data class Film(
    val id: String,
    val screen: Screen,
    val coherence: CoherenceFilmInfo? = null
)
